// Dependencies
import Accordion from '../basics/accordion';
import debounce from '../principles/performance/debounce';
import matchViewport from '../principles/responsive/match-viewport';

//

(function () {

  var
  accordion,
  $footer = $('.site-footer'),
  $accordionHeadings = $footer.find(`
    .site-footer__top .site-footer__heading,
    .site-footer-set--about-resources .site-footer__heading,
    .site-footer-set--about-company .site-footer__heading`),
  isSetup = false,

  init = function () {
    if (matchViewport('width-l')) {
      teardown();
    } else {
      setup();
    }
  },

  moveAttributes = function (attributes, $source, $target) {
    $.each(attributes, function (index, value) {
      var attribute = value;

      value = $source.attr(value);
      $source.removeAttr(attribute);
      $target.attr(attribute, value);
    });
  },

  setup = function () {
    if (!isSetup) {
      isSetup = true;

      $.each($accordionHeadings, function (index, value) {
        var $heading = $(value);
        $heading.wrap('<button/>');
        moveAttributes(['aria-controls', 'id', 'role'], $heading, $heading.parent('button'));
      });

      accordion = new Accordion($footer);
    }
  },

  teardown = function () {
    if (isSetup) {
      isSetup = false;
      accordion.teardown();

      $.each($accordionHeadings, function (index, value) {
        var $heading = $(value);
        moveAttributes(['aria-controls', 'id', 'role'], $heading.parent('button'), $heading);
        $heading.unwrap('<button/>');
      });
    }
  };

  init();
  $(window).on('resize', debounce(init, 250));
}());



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/components/footer-accordion.js
 **/